import Tooltip from '../../components/base/Tooltip';

/**
 * Активация тултипов
 */
export default () => {
    const $tooltipMessages = $('.tooltip--message');
    $tooltipMessages.each((i, item) => {
        const $tooltip = $(item);
        const tooltipMessage = new Tooltip($tooltip);
        tooltipMessage.init({
            type: 'tooltip',
            content: $tooltip.attr('data-tooltip-text'),
        });
        /** fix жмака по тултипу внутри label, с целью отображения тултипа, а не отработки label */
        $tooltip.click(e => {
            console.log(e.target);
            if (e.target.classList.contains('tooltip__trigger')) {
                e.preventDefault();
            }
        });
    });
};
